'use client'

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts'
import type { Factor } from '@/consultant-study/types'

interface ScreePlotProps {
  factors: Factor[]
}

export function ScreePlot({ factors }: ScreePlotProps) {
  const data = factors.map((f) => ({
    name: f.id,
    eigenvalue: f.eigenvalue,
  }))

  return (
    <ResponsiveContainer width="100%" height={380}>
      <LineChart data={data} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis
          dataKey="name"
          tick={{ fontSize: 12 }}
          label={{ value: 'Factor', position: 'insideBottom', offset: -4, fontSize: 13 }}
        />
        <YAxis
          domain={[0, 12]}
          tick={{ fontSize: 12 }}
          label={{ value: 'Eigenvalue', angle: -90, position: 'insideLeft', fontSize: 13 }}
        />
        <Tooltip
          formatter={(value: number) => [value.toFixed(3), 'Eigenvalue']}
          contentStyle={{ fontSize: 13 }}
        />
        <ReferenceLine
          y={1}
          stroke="#94a3b8"
          strokeDasharray="6 4"
          label={{ value: 'Kaiser criterion (1.0)', position: 'right', fontSize: 11, fill: '#64748b' }}
        />
        <Line
          type="monotone"
          dataKey="eigenvalue"
          stroke="#F17922"
          strokeWidth={2.5}
          dot={{ r: 5, fill: '#F17922', stroke: '#fff', strokeWidth: 2 }}
          activeDot={{ r: 7 }}
          label={{ position: 'top', fontSize: 10, fill: '#374151' }}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
